import { render } from "./KoruTree.vue?vue&type=template&id=047b67c8&ts=true"
import script from "./KoruTree.vue?vue&type=script&lang=ts"
export * from "./KoruTree.vue?vue&type=script&lang=ts"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__